import React from 'react';
import { Link } from 'react-router-dom';
import DynamicFormIcon from '@mui/icons-material/DynamicForm';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import ViewCarouselIcon from '@mui/icons-material/ViewCarousel';
import PollIcon from '@mui/icons-material/Poll';
import '../styles/_formpreset.scss';

const FormPreset = () => {
  const formPresets = [
    {
      id: 'new-form',
      title: 'New Form',
      description: 'Create a new blank form from scratch',
      icon: <DynamicFormIcon />,
      link: '/create-form',
      color: 'from-indigo-500 to-purple-600'
    },
    {
      id: 'contact-us',
      title: 'Contact-us Form',
      description: 'Create a simple contact us form',
      icon: <ContactMailIcon />,
      link: '/create-form?preset=contactUs',
      color: 'from-blue-500 to-cyan-600'
    },
    {
      id: 'whatsapp',
      title: 'WhatsApp Form',
      description: 'Create a WhatsApp us form',
      icon: <WhatsAppIcon />,
      link: '/create-form?preset=WhatsApp',
      color: 'from-green-500 to-emerald-600'
    },
    {
      id: 'support',
      title: 'Support Form',
      description: 'Create a Get Support/Ticket form',
      icon: <SupportAgentIcon />,
      link: '/create-form?preset=Support',
      color: 'from-amber-500 to-orange-600'
    },
    {
      id: 'multi-step',
      title: 'Multi-Step Form',
      description: 'Create a Multisteps form',
      icon: <ViewCarouselIcon />,
      link: '/create-form?preset=multiStep',
      color: 'from-rose-500 to-pink-600'
    },
    {
      id: 'survey',
      title: 'Survey Form',
      description: 'Create a Survey form',
      icon: <PollIcon />,
      link: '/create-form?preset=Survey',
      color: 'from-violet-500 to-fuchsia-600'
    }
  ];

  return (
    <div className="form-preset-container">
      <div className="form-preset-header">
        <div className="header-icon">
          <DynamicFormIcon />
        </div>
        <h1>Form Presets</h1>
        <p>Choose a template to get started quickly</p>
      </div>

      <div className="form-preset-grid">
        {formPresets.map((preset) => (
          <div key={preset.id} className="form-preset-card">
            <div className={`card-gradient bg-gradient-to-r ${preset.color}`}></div>
            <div className="card-content">
              <div className="card-icon">{preset.icon}</div>
              <h3>{preset.title}</h3>
              <p>{preset.description}</p>
              <Link to={preset.link} className="create-btn">
                <AddCircleIcon />
                Create Form
              </Link>
            </div>
          </div>
        ))}
      </div>

      <div className="form-preset-footer">
        <p>Need something custom? <Link to="/create-form">Start from scratch</Link></p>
      </div>
    </div>
  );
};

export default FormPreset;